(function ($) {
    "use strict";

    // Declining asks the reviewer why; the chosen reason picks the email the
    // applicant receives.
    $('body').on('click', '[data-toggle="decline"]', function (event) {
        event.preventDefault();
        var $form = $($(this).data('target'));
        var reasons = $(this).data('reasons');

        Swal.fire({
            title: 'Decline application',
            text: 'Why is this application being declined?',
            icon: 'warning',
            input: 'select',
            inputOptions: reasons,
            inputPlaceholder: 'Select a reason',
            showCancelButton: true,
            confirmButtonText: 'Decline',
            cancelButtonText: 'Cancel',
            inputValidator: function (value) {
                if (!value) {
                    return 'Please select a reason';
                }
            }
        }).then(function (result) {
            if (!result.isConfirmed || $form.data('is-submitting')) {
                return;
            }
            // The global submit handler sets is-submitting itself; setting it
            // here first makes that handler treat this as a double submit.
            $form.find('input[name="reason"]').val(result.value);
            $form.submit();
        });
    });
})($);
